(function (window, $j) {
    function setBrowserDetectCookie() {
        if ($j.cookie('ShowModal') == null) {
            $j.cookie('ShowModal', true);
        }
    }

    function msieversion() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0) // If Internet Explorer, return version number
        {
            var browserVersion = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
            if (browserVersion < 9 && !window.isHomePage) {

                var mbackdrop = $j('<div class="modal-backdrop fade in"></div>');

                $j("body").prepend("<div style='font-color: black;' id='updateBrowser'>Your version of Microsoft Internet Explorer is not supported for secure online transactions. Please use another browser or click <a style='font-color: #0000FF;' href='http://windows.microsoft.com/en-us/internet-explorer/download-ie' target='blank'>here</a> to update IE to make a reservation.</div>");
                $j("#updateBrowser").fadeIn(500);
                $j("#mainform").css("margin-top", $j("#updateBrowser").outerHeight());

                $j(document).on('click', '.modal #cancelModal', function (e) {
                    $j('#confirmationModal').hide();
                    if (browserVersion === 6) {

                        $j("#modalOverlay2").remove();
                    } else {
                        mbackdrop.remove();
                    }
                    var date = new Date();
                    date.setDate(date.getDate() + 1);
                    $j.cookie('ShowModal', false, { expires: date });

                });

                $j(document).on('click', '.modal #updateBrowserNow', function (e) {
                    window.location.href = "http://windows.microsoft.com/en-us/internet-explorer/download-ie";
                });

                if ($j.cookie('ShowModal') === "true") {
                    $j('#confirmationModal').show().addClass("in");

                    if (browserVersion === 6) {
                        $j("body").append("<div id='modalOverlay2'></div>");
                        $j("#modalOverlay2").height($j("body").outerHeight() + 500);
                    } else {
                        $j('body').append(mbackdrop);
                    }
                }
            }
        }
    }

    $j(document).ready(function () {
        setBrowserDetectCookie();
        msieversion();
    });


})(window, $j);